//
//
//
//
//
//

export default {
  name: "showIcon-editor",
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  }
};